window.addEventListener('load', function() {
  document.querySelectorAll('.order-value-booster-block').forEach( function(widget) {
    let id = widget.getAttribute('id');
    console.log("ID:", id);
    waitForElement(`#essential_product_slider_${id}`, 5000)
    .then(function(el) {
      if(!window.Glide) return;
      el.querySelectorAll('.glide__slide--clone').forEach( function(clone) {
        clone.remove();
      });
      
      let slider = new Glide(`#essential_product_slider_${id}`, {
        type: 'carousel',
        gap: 30,
        peek: 0,
        focusAt: 'center',
        autoplay: 5000,
        breakpoints: {
            4000: { perView: 1 },
            768: { perView: 1 },
            480: {  perView: 1 },
            320: { perView: 1 }
        }
      });

      slider.destroy();

      let s = document.querySelectorAll(".essential_product_slider_glide__arrow");
      s.forEach((e) => {
          e.addEventListener("click", () => {
              slider.go(e.dataset.glideDir);
          });
      });
      let p = new ResizeObserver( () => {
          slider.update()
      });
      p.observe(document.getElementById(`essential_product_slider_${id}`));
      slider.mount();
      // console.log("startAt:", slider.settings.startAt);
      // console.log("focusAt:", slider.settings.focusAt);
      // console.log("SliderType:", slider.type);
      // console.log("perView:", slider.settings.perView);
      // console.log("SliderWidth:", slider.settings.slideWidth);

      document.querySelectorAll(`free_shipping_card_product_cta_${id}`).forEach((e) => {
        e.addEventListener('click', () => {
          setTimeout(() => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          }, 1000);
        });
      });
    })
    .catch(function(err) {
      console.warn(err);
    });
  });          

  function waitForElement(selector , timeout = 10000) {
    return new Promise(function(resolve, reject) {
      const interval = 1000; // ms
      const start = Date.now();

      const timer = setInterval(function() {
        let el = document.querySelector(selector);
        if (el) {
          clearInterval(timer);
          resolve(el);
        } else if (Date.now() - start > timeout) {
          clearInterval(timer);
          reject(new Error('Timed out waiting for ' + selector));
        }
      }, interval);
    });
  }
});

function addToCartEssentialApps(e, t) {
  console.log("HER");
  fetch(window?.Shopify?.routes?.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items: [{
        id: e,
        quantity: 1
      }, ]
    })
  }).then(e => {
    if (window.freeShippingBarConfigs && 200 === e.status) {
      let r = window.location && body.classList.contains('open-cc');
      r ? r && window.location.reload() : (window.Shopify?.shop !== "atrangi-studio.myshopify.com" && window.Shopify?.shop !== "bouqie.myshopify.com" && triggerSideCart(t),
      pollCartTotalEssentialApps())
    } else
      console.log(e);
    return e.json()
  }
  ).then(e => {
    if (e.items) {
      let r = 0;
      window.Shopify.currency && window.Shopify.currency.rate && e.items[0]?.price && (r = Math.round(e.items[0]?.price / window.Shopify.currency.rate));
      let i = window?.Shopify?.currency?.active || "";
      fetch("https://essential-apps-analytics.herokuapp.com/add_to_cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          shop: window.Shopify.shop,
          booster: t,
          currency: i,
          price: e.items[0]?.price,
          mainCurrency: window.essentialOrderValueBoosterMeta?.mainCurrency,
          total: r
        })
      })
    }
  }
  ).catch(e => {
    console.error("Error:", e)
  })
  .finally( () => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  })
}